module TableRangeSelection {
  const selectedRowCssClass = "multiselect";

  let FirstElement: JQuery<HTMLElement> = null;
  let SecondElement: JQuery<HTMLElement> = null;

  export function construct() {
    $("tbody tr").click(handleSelectionInput);
  }

  function handleSelectionInput(event: JQuery.Event<HTMLElement, null>) {
    const clickedTr = $(event.target).parents("tr");

    //If clicking a row not inside the range without shift held, remove selection
    if (!event.shiftKey) {
      var selectedRows = getSelectedRows();
      if (selectedRows == null) {
        return;
      }
      if (selectedRows.index(clickedTr) === -1) {
        clearSelection();
        return;
      }

      return;
    }

    //If the first element has not yet been selected we should
    //record this as the first element.
    if (FirstElement == null) {
      FirstElement = clickedTr;
    }
    //Otherwise we have both the start and finish and can
    //proceed with the multiselect
    else {
      SecondElement = clickedTr;
    }

    styleSelectedElements();
    //Browsers also handle shift+click.  Deselect anything they selected here.
    document.getSelection().removeAllRanges();
  }

  function clearSelection() {
    FirstElement = null;
    SecondElement = null;
    styleSelectedElements();
  }

  export function getSelectedRows(): JQuery<HTMLElement> {
    if (FirstElement == null || SecondElement == null) {
      return null;
    }
    if (FirstElement.index() < SecondElement.index()) {
      return FirstElement.nextUntil(SecondElement).add(SecondElement).add(FirstElement);
    }
    else {
      return FirstElement.prevUntil(SecondElement).add(SecondElement).add(FirstElement);
    }
  }

  export function getSelectedCells(triggeringElement: JQuery<HTMLElement>): JQuery<HTMLElement>[] {
    const td = triggeringElement.is("td") ? triggeringElement : triggeringElement.parents("td");
    const tr = td.parents("tr");

    const trs = getSelectedRows();
    if (trs == null || trs.length === 0 || trs.index(tr) === -1) {
      return null;
    }

    const columnIndex = tr.find("td").index(td);
    if (columnIndex === -1) {
      console.log("Triggering element not found in parent row.");
      return;
    }

    let result = [];
    trs.each(function (index: number) {
      const tr = $(this);
      const td = tr.children("td").eq(columnIndex);
      result.push(td);
    });
    return result;
  }

  function styleSelectedElements() {
    //Remove any previous selections
    $(`.${selectedRowCssClass}`).removeClass(selectedRowCssClass);

    //Selection is incomplete, highlight FirstElement
    if (SecondElement == null) {
      if (FirstElement != null) {
        FirstElement.addClass(selectedRowCssClass);
      }
    }
    //Selection is complete, highlight all selected rows
    else {
      getSelectedRows().addClass(selectedRowCssClass);
    }
  }
}

$(document).ready(() => {
  TableRangeSelection.construct();
});